import { GetStaticProps } from 'next';
import { BASE_PATHS } from '@belong/common';
import { fetchRegionsService } from 'src/api/region';
import { SitemapPage, ServerProps } from 'src/features/sitemap/components/sitemap-page/sitemap-page';
import { SITEMAP_TABS } from 'src/features/sitemap/constants';
import { buildServerClient } from 'src/utils/server-client';

export const getStaticProps: GetStaticProps = async () => {
  const props: ServerProps = {
    coverageCities: [],
    activeRegions: [],
    coverageRegions: [],
    coverageNeighborhoods: [],
    tab: SITEMAP_TABS[3].key,
  };

  const apiClient = buildServerClient();

  try {
    const regions = await fetchRegionsService(apiClient);

    props.activeRegions = regions
      .filter(({ status }) => status === 'Active')
      .map((region) => ({
        href: `${BASE_PATHS.HOME}/${region.nameKebabCase}`,
        displayName: `${region.region}`,
      }))
      .sort((a, b) => a.displayName.localeCompare(b.displayName));
  } catch (e) {
    console.error(e);
  }

  return { props, revalidate: 60 * 60 * 24 }; // 1 day
};

export default SitemapPage;
